import EmailCampaignForm from "@crm-src/components/email-campaign-form"

export default function CreateEmailCampaignPage() {
  return <EmailCampaignForm />
}
